import { targetChainId, chainName, nativeToken, rpcUrl } from '../constant/constant';
import { chain, blockExplorerUrl } from './wagmiConfig';
import { rpcHttpUrls } from './rpcEnv';

/** MetaMask rejects `wallet_addEthereumChain` unless decimals is 18. */
const WALLET_ADD_CHAIN_DECIMALS = 18;

/** EIP-3085 params for `wallet_addEthereumChain`. */
export function getAddEthereumChainParams() {
    // MetaMask should use the primary Alchemy URL only — listing broken/
    // rate-limited fallbacks makes wallet sends fail while Tenderly still passes.
    const rpcList =
        rpcHttpUrls.length > 0
            ? [rpcHttpUrls[0]]
            : rpcUrl
              ? [rpcUrl]
              : [...(chain.rpcUrls?.default?.http || [])].slice(0, 1);

    const chainIdHex = `0x${Number(targetChainId).toString(16)}`;

    const params = {
        chainId: chainIdHex,
        chainName: chainName || chain.name || 'Arc',
        nativeCurrency: {
            name: nativeToken || chain.nativeCurrency?.name || 'USDC',
            symbol: nativeToken || chain.nativeCurrency?.symbol || 'USDC',
            decimals: WALLET_ADD_CHAIN_DECIMALS,
        },
        rpcUrls: rpcList,
    };

    if (blockExplorerUrl) {
        params.blockExplorerUrls = [blockExplorerUrl];
    }

    return params;
}

/** True when the wallet does not have the target chain configured yet. */
export function isChainNotAddedError(error) {
    if (!error) return false;

    const code = error?.code ?? error?.cause?.code;
    if (code === 4902) return true;

    const name = String(error?.name || error?.cause?.name || '');
    if (name === 'ChainNotConfiguredError') return true;

    const msg = String(
        error?.message || error?.shortMessage || error?.cause?.message || '',
    ).toLowerCase();

    return (
        msg.includes('unrecognized chain') ||
        msg.includes('chain has not been added') ||
        msg.includes('chain not added') ||
        msg.includes('unknown chain') ||
        (msg.includes('chain') && msg.includes('not found'))
    );
}
